import { Application } from '@hotwired/stimulus'

import PackageSelectController from './package_select_controller'
import QuantityController from './quantity_controller'

const application = Application.start()

application.register('package-select', PackageSelectController)
application.register('quantity', QuantityController)
